import React from 'react'

const PreLoader = () => (
  <div
    className="pre-loader gradient-color"
    style={{
      zIndex: 10000,
      backgroundColor: 'white',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }}
  >
    <div className="loader" />
  </div>
)

export default PreLoader



// WEBPACK FOOTER //
// ./src/components/PreLoader.js